<div [ngClass]="{'mox-ui-page-container': claim.isMox()}">
  <div class="prev-bar">
    <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i> {{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}} </a>
    <a (click)="back()" *ngIf="claim.isMox()" class="back-chevron"></a>
  </div>
  <div class="col-12">
    <h5>{{ 'claimSection.generalLabels.whatHappened' | translate}}</h5>
    <p>{{ 'homeProduct.responsibility.title' | translate}}</p>
  </div>
  <BR>
  <div class="row col-12">
    <div [ngClass]="claim.isMox() ? 'col-lg-12 col-md-12' : 'col-lg-9 col-md-12'">
      <form>
        <div class="form-group">
          <qnect-ui #HOME_RESP_OTHERS [fieldId]="'HOME_RESP_OTHERS'" [formGroup]="genResponsibilityForm" name="hasOtherPersonInvolved"></qnect-ui>
        </div>
        <ng-container *ngIf="genResponsibility.getHasOtherPersonInvolved()">
          <div class="form-group">
            <qnect-ui #HOME_RESP_NAME [fieldId]="'HOME_RESP_NAME'" [formGroup]="genResponsibilityForm" name="contactName"></qnect-ui>
          </div>
          <div class="form-group">
            <qnect-ui #HOME_RESP_PHONENUM [fieldId]="'HOME_RESP_PHONENUM'" [formGroup]="genResponsibilityForm" name="contactNumber"></qnect-ui>
          </div>
          <div class="form-group">
            <qnect-ui #HOME_RESP_ADDRESS [fieldId]="'HOME_RESP_ADDRESS'" [formGroup]="genResponsibilityForm" name="contactAddress"></qnect-ui>
          </div>
          <div class="form-group">
            <qnect-ui #HOME_RESP_DESC [fieldId]="'HOME_RESP_DESC'" [formGroup]="genResponsibilityForm" name="description"></qnect-ui>
          </div>
        </ng-container>
      </form>
    </div>
    <div [ngClass]="claim.isMox() ? 'd-none' : 'col-lg-3 col-xl-3 col-md-12'">
      &nbsp;
    </div>
  </div>
  <div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" class="Tertiary" [hidden]="claim.isMox()"> {{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn btn-primary float-right new-btn">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right"></i></button>
  </div>
  <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>
